import { CashBankSummaryEntity, CashBankSummaryParams } from "../entities";
import { CashAndBankRepository } from "../repositories";

export class GetCashBankSummaryUseCase {
  constructor(private repository: CashAndBankRepository) {}

  async execute(params?: CashBankSummaryParams): Promise<CashBankSummaryEntity> {
    return this.repository.fetchSummary(params);
  }
}
